import React from 'react';
import { VStack, Box, Text, Heading } from 'native-base';

// Assets & Icons
import { theme } from '@breakroom-nx/assets';

// Components
import { PrimaryButton, UserAvatar, PointsTag } from '../../';

export enum ChatRoomNotificationType {
  Preview,
  Expired,
}

export interface ChatRoomNotificationProps {
  notificationType: ChatRoomNotificationType;
  action?: any;
  bgColor?: string;
  isLoading?: boolean;
}

export function ChatRoomNotification({
  notificationType,
  action,
  bgColor,
  isLoading,
}: ChatRoomNotificationProps) {
  return (
    <Box
      overflow={'hidden'}
      marginTop={'-60px'}
      width={'full'}
      px={'1.25rem'}
      pb={'1.25rem'}
      bottom={0}
    >
      <VStack
        rounded={25}
        space={5}
        textAlign={'center'}
        bg={bgColor}
        padding={{
          base: 15,
          lg: 30,
        }}
      >
        <VStack space={3}>
          <Heading fontSize={{ base: 24, lg: 30 }} lineHeight={34}>
            <Text
              color={
                notificationType === ChatRoomNotificationType.Expired
                  ? theme.colors.dark.textContrast
                  : theme.colors.primary[400]
              }
            >
              {notificationType === ChatRoomNotificationType.Expired
                ? 'Room Expired'
                : 'You are previewing the room.'}
            </Text>
          </Heading>
          <Text
            color={theme.colors.dark.textContrast}
            fontSize={{ base: 14, lg: 16 }}
            fontWeight={'bold'}
          >
            {notificationType === ChatRoomNotificationType.Expired
              ? "The activity in this room died out. Don't worry, go out there and find new rooms and new friends! We will remove this room for you soon."
              : 'Not every room you join will be perfectly tailored to you. So take some time to see what people are talking about and decide whether you want to join the discussion!'}
          </Text>
        </VStack>
        {notificationType === ChatRoomNotificationType.Preview && (
          <PrimaryButton
            width={'100%'}
            color={theme.colors.surface[100]}
            isLoading={isLoading}
            disabled={isLoading}
            text={'Join Room'}
            endIcon={<PointsTag amount={30} payment={false} fontSize={12} />}
            onPress={action}
          />
        )}
      </VStack>
    </Box>
  );
}

export default ChatRoomNotification;
